
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { UserService } from '@/services/index'
import { roleOptions } from '@/constants/role'

@Component({
    components: {
    }
})
export default class extends Vue {
    private userRules = {
        name: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
            { min: 6, message: '密码不能少于6个字符', trigger: 'blur' }
        ]
    }
    private userForm: any = {
        name: '',
        password: '',
        mobile: '',
        email: '',
        department: '',
        role: 1
    }
    private roleOptions = roleOptions
    private loading: boolean = false

    private mounted() {
        this.initData()
    }

    private async initData() {
        const userId = this.$route.params.id
        const result = await UserService.getUserInfo({ id: userId })
        if (result.status === 200) {
            const { name, mobile, role, email, department } = result.data
            this.userForm = {
                name: name || '',
                mobile: mobile || '',
                email: email || '',
                department: department || '',
                role: Number(role)
            }
        }
    }

    private onUpdate() {
        (this.$refs.userForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const { name, password, mobile, role, email, department } = this.userForm
                const params = { id: this.$route.params.id, name, password, mobile, role, email, department }
                const result = await UserService.updateUser(params)
                if (result.status === 200) {
                    this.$message({ type: 'success', message: '修改成功' })
                    // 重新拉取最新数据回显, 不清空表单
                    this.initData()
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            } else {
                return false
            }
        })
    }

    private onCancel() {
        this.$router.go(-1)
    }

    private onReset() {
        this.initData()
        this.$message({ type: 'info', message: '已重置为最新信息' })
    }
}
